import { render, staticRenderFns } from "./abnormal-table.vue?vue&type=template&id=01d3267a"
import script from "./abnormal-table.vue?vue&type=script&lang=js"
export * from "./abnormal-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports